import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { AppService, AppDateAdapter, APP_DATE_FORMATS } from "../../../../services/app.service";
import { ShipperService } from "../../../../services/shipper.service";
import { MasterService } from "../../../../services/master.service";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";

@Component({
    selector: 'app-dist-order-detail',
    templateUrl: './dist-order-detail.component.html',
    styleUrls: ['./dist-order-detail.component.scss'],
    providers: [
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }
    ]
})
export class DistOrderDetailComponent implements OnInit {
    @Input() parent: any;
shipperList: any = [];
orderStatusList: any = [];
orderTypeList: any = [];
articalList: any = [];
formGroup: FormGroup;
formGroupErrors: any;
showSaveButton : Boolean = true;
translations: any;
otColor = '';
oStatus = '';
constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    public shipperService: ShipperService,
    public masterService: MasterService,
) {
    this.appService.showLoading();
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');
    this.setPageTranslations();
    this.formGroupErrors = {
        OrderNo: {},
        RegistrationDate: {},
        ShipperId: {},
        InvoiceNo: {},
        AticleId: {},
        TypeId: {},
        Status: {}
    };
    
}

ngOnInit() {
    this.loadFormGroup();
    this.bindOrderStatus();
    this.bindShipper();
    this.bindOrderType();
    this.bindArticle();

    this.appService.hideLoading();
}

setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}
bindShipper(): void {
    this.shipperService
    .list(this.parent.order.ShipperId)
    .subscribe(
    res => this.getShipperDetailsSuccess(res),
    error => this.apiFaillure(error)
    );
}
getShipperDetailsSuccess(res): void {
    if (res.Data != null) {
        this.shipperList = JSON.parse(res.Data);
        if(this.parent.order.ShipperId <= 0){
            this.parent.order.ShipperId = this.shipperList[0]['Id'];
        }
    } else {
    this.apiFaillure(res.Message);
}
}
apiFaillure(error): void {
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

bindOrderStatus(): void {
    this.masterService
    .selectSysData("OrderStatus", this.parent.order.Status)
    .subscribe(
    res => this.getOrderStatussSuccess(res),
    error => this.apiFaillure(error)
    );
}
getOrderStatussSuccess(res): void {
    if (res.Data != null) {
        this.orderStatusList = JSON.parse(res.Data);
        for (let i = 0; i < this.orderStatusList.length; i++) {
            if (this.parent.order.Status == this.orderStatusList[i].Id) {
                this.oStatus = this.orderStatusList[i].Value;
            }
        }
    } else {
    this.apiFaillure(res.Message);
}
}

bindOrderType(): void {
    this.masterService
    .selectSysData("OrderType", this.parent.order.TypeId)
    .subscribe(
    res => this.getOrderTypesSuccess(res),
    error => this.apiFaillure(error)
    );
}
getOrderTypesSuccess(res): void {
    if (res.Data != null) {
        this.orderTypeList = JSON.parse(res.Data);
        for (let i = 0; i < this.orderTypeList.length; i++) {
            if (this.parent.order.TypeId == this.orderTypeList[i].Id) {
                this.otColor = this.orderTypeList[i].Value;
            }
        }
    } else {
    this.apiFaillure(res.Message);
}
}

bindArticle(): void {
    this.masterService
    .selectSysData("Article", this.parent.order.AticleId)
    .subscribe(
    res => this.getArticlesSuccess(res),
    error => this.apiFaillure(error)
    );
}
getArticlesSuccess(res): void {
    if (res.Data != null) {
        this.articalList = JSON.parse(res.Data);
    } else {
    this.apiFaillure(res.Message);
}
}

loadFormGroup() {
     if (this.parent.order.Status == 152 && this.showSaveButton) {
        this.formGroup = this.formBuilder.group({
            OrderNo: [{
                value: '',
                disabled: true
            }],
            RegistrationDate: [{
                value: '',
                disabled: true
            }, Validators.required],
            ShipperId: [{
                value: '',
                disabled: true
            }, Validators.required],
            InvoiceNo: [{
                value: '',
                disabled: true
            }, Validators.required],
            AticleId: [{
                value: '',
                disabled: true
            }, Validators.required],
            TypeId: [{
                value: '',
                disabled: true
            }, Validators.required],
            Status: [ "", Validators.required],
            D_PlannedDate: ["", Validators.required],
            D_ActualDate: ["", Validators.required]
        });
    }else{
        this.formGroup = this.formBuilder.group({
            OrderNo: [{
                value: '',
                disabled: true
            }],
            RegistrationDate: [{
                value: '',
                disabled: true
            }, Validators.required],
            ShipperId: [{
                value: '',
                disabled: true
            }, Validators.required],
            InvoiceNo: [{
                value: '',
                disabled: true
            }, Validators.required],
            AticleId: [{
                value: '',
                disabled: true
            }, Validators.required],
            TypeId: [{
                value: '',
                disabled: true
            }, Validators.required],
            Status: [{value: "", disabled: !this.showSaveButton }, Validators.required],
            D_PlannedDate: [{value: "", disabled: true }],
            D_ActualDate: [{value: "", disabled: true }]
        });
    }

    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(
            this.formGroup,
            this.formGroupErrors
        );
        this.parent._orderFormInvalid = this.formGroup.invalid;
        this.appService.setFormValid(this.formGroup.invalid);
    });

}

changeColor(e) {
    ;
    for (let i = 0; i < e.source.options.length; i++) {
        if (e.value == e.source.options._results[i].value) {
            e.source._elementRef.nativeElement.firstElementChild.firstElementChild.style.color = e.source.options._results[i]._element.nativeElement.style.color;
        }
    }
}
}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/dist-order-detail/dist-order-detail.component.ts